import { z } from "zod";

export const heightFormSchema = z.object({
  value: z
    .string()
    .regex(
      /^(\d+\s*?f(?:ee)?t\s*(?: ?\d+\s*?in(?:ches)?)?|\d+\s*?in(?:ches)?|\d+\s*?m\s*(?: ?\d+\s*?cm)?|\d+\s*?cm)\s*$/,
      "Height must be in format '6ft', '72in', '6ft2in', '1m', '180cm', or '1m80cm' (spaces allowed)",
    ),
  effectiveDateTime: z.string().min(1, "Date is required"),
});

export const weightFormSchema = z.object({
  value: z
    .string()
    // Updated regex to accept free text like "200lbs" or "75kg"
    .regex(
      /^(\d+(?:\.\d+)?\s*(kg|lbs))$/,
      "Weight must be in format '70kg' or '154.5lbs'",
    ),
  effectiveDateTime: z.string().min(1, "Date is required"),
});

export const bpFormSchema = z.object({
  value: z
    .string()
    .regex(/^\d+\s*?\/\s*?\d+\s*?$/, "BP must be in format '120/80'")
    .refine(
      (val) => {
        const [systolic, diastolic] = val.split("/").map(Number);
        return systolic > diastolic; // Basic validation that systolic should be higher
      },
      { message: "Systolic must be higher than diastolic" },
    ),
  effectiveDateTime: z.string().min(1, "Date is required"),
});

export const heartRateFormSchema = z.object({
  value: z.string().regex(/^\d+$/, "Heart rate must be a whole number"),
  effectiveDateTime: z.string().min(1, "Date is required"),
});

export const bodyTemperatureFormSchema = z.object({
  value: z
    .string()
    .regex(/^\d+(\.\d+)?$/, "Body temperature must be a number "),
  effectiveDateTime: z.string().min(1, "Date is required"),
});

export const headCircumferenceFormSchema = z.object({
  value: z
    .string()
    .regex(
      /^\d+(\.\d+)?\s*?cm$/,
      "Head circumference must be in format '45 cm'",
    ),
  effectiveDateTime: z.string().min(1, "Date is required"),
});
